import type { XYCoord } from 'react-dnd';
import type { DragData } from '../../domain/dnd/types';
import { blockIdsInDragItem } from '../../domain/selection/block-bulk-ops';
import { rowIdsInDragItem } from '../../domain/selection/row-bulk-ops';
import { blockGhostClientDelta, multiDragMirrorClientDelta } from './block-drag-mirror';

export function ghostLayerTransform(
  sourceClientOffset: XYCoord | null,
  drag: DragData | null,
): string | undefined {
  if (!sourceClientOffset || !drag) {
    return undefined;
  }

  let { x, y } = sourceClientOffset;

  if (drag.kind === 'item-block') {
    const blockIds = blockIdsInDragItem(drag);
    const delta =
      blockIds.length > 1
        ? multiDragMirrorClientDelta('block', blockIds, drag.blockId)
        : blockGhostClientDelta(drag.blockId);
    x += delta.x;
    y += delta.y;
  }

  if (drag.kind === 'item-row') {
    const rowIds = rowIdsInDragItem(drag);
    if (rowIds.length > 1) {
      const delta = multiDragMirrorClientDelta('row', rowIds, drag.rowId);
      x += delta.x;
      y += delta.y;
    }
  }

  return `translate(${x}px, ${y}px)`;
}
